import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import MUIRichTextEditor from 'mui-rte'
import { markdownToDraft } from 'markdown-draft-js'
import editorStateToMarkdown from 'lib/rte-utils/editor-state-to-markdown'
import { useStyles as useFlowStyles } from 'pages/pga-coach/bookings/events/edit/edit-event-form/styles'

const CONTROLS = ['bold', 'italic', 'strikethrough', 'bulletList', 'link']

export default function MessageEditor({ value, placeholder, onChange }) {
  const flowClasses = useFlowStyles()
  const defaultValue = useRef(JSON.stringify(markdownToDraft(value || '')))
  const latest = useRef(value)

  const handleChange = editorState => {
    // Selection and focus changes also reach here; only real edits sync.
    if (!editorState.getLastChangeType()) return
    const markdown = editorStateToMarkdown(editorState)
    if (markdown === latest.current) return
    latest.current = markdown
    onChange(markdown)
  }

  return (
    <div
      className={flowClasses.editorRoot}
      data-testid="campaign-message-editor"
    >
      <MUIRichTextEditor
        className={flowClasses.editor}
        label={placeholder}
        controls={CONTROLS}
        defaultValue={defaultValue.current}
        onChange={handleChange}
      />
    </div>
  )
}

MessageEditor.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}
